import React, { useState, useEffect } from "react";
import cl from "classnames";
import PropTypes from "prop-types";
import AsyncSelectField from "./AsyncSelectField";
import { debouncePromise } from "../../../utils/debounce";
import { locations } from "venuescanner-js/vanilla/components/locations";
import isSSR from "venuescanner-js/services/isSSR";
import ErrorMessage from "venuescanner-js/react/components/Form/Notifications/ErrorMessage";

import classes from "./styles.module.scss";

const DetectLocationButton = ({ clearButton, onClick }) => {
  const [isGettingLocation, gettingLocation] = useState(false);

  return (
    <button
      className={cl(classes.DetectLocation, {
        [classes.DetectLocationFetch]: isGettingLocation,
        [classes.DetectLocationWithClear]: clearButton,
      })}
      aria-label="Detect location"
      onClick={() => {
        gettingLocation(true);
        onClick().then(() => {
          gettingLocation(false);
        });
      }}
    ></button>
  );
};
// eslint-disable-next-line compat/compat
const LocationField = React.forwardRef(
  (
    {
      clearButton = true,
      absolute = false,
      base = "",
      id,
      filter = {},
      isForm,
      onChange,
      value,
      name,
      errors,
      fullLocation = false,
      inputStyles = false,
      ...props
    },
    ref
  ) => {
    const [location, setLocation] = useState(value);
    useEffect(() => {
      if (!location) {
        if (!isSSR()) {
          locations
            .autoCurrentPosition()
            .then((loc) => {
              // console.log({ currentPosition: loc })
              if (loc && loc.id) {
                setLocation({
                  value: loc.slug,
                  label: loc.name,
                  id: loc.id,
                });
                onChange(
                  fullLocation
                    ? loc
                    : {
                        value: loc.slug,
                        label: loc.name,
                        id: loc.id,
                      }
                );
              }
            })
            .catch((e) => {});
        }
      }
    }, []);

    return (
      <div className={cl(classes.LocationWrapper)}>
        <AsyncSelectField
          // placeholder={isForm ? 'Where are you looking to book?' : 'Location'}
          inputProps={{ id, name, "aria-label": "Location search" }}
          placeholder={"Location"}
          ref={ref}
          getResults={debouncePromise(locations.getResults(base, filter), 400)}
          cacheOptions={false}
          filter={filter}
          defaultOptions
          openMenuOnFocus
          inputStyles={inputStyles}
          absolute={absolute}
          noOptionsMessage={() => "No results. Is the spelling correct?"}
          clearButton={clearButton}
          onChange={(loc) => {
            setLocation(loc);
            // console.log({ loc })
            if (fullLocation) {
              const place = locations.cachedLocationBySlug(loc.value);
              // console.log(place)
              onChange(place);
            } else {
              onChange(loc);
            }
          }}
          value={location}
          {...props}
        >
          <DetectLocationButton
            clearButton={clearButton}
            onClick={() => {
              // eslint-disable-next-line compat/compat
              return new Promise((resolve) => {
                locations.currentPosition().then((loc) => {
                  console.log({ currentPosition: loc });
                  if (loc && loc.id) {
                    onChange(
                      fullLocation
                        ? loc
                        : {
                            value: loc.slug,
                            label: loc.name,
                            id: loc.id,
                          }
                    );
                    resolve();
                  }
                });
              });
            }}
          />
          {/* <vs-country/> */}
        </AsyncSelectField>
        <ErrorMessage error={errors && errors[name]} />
      </div>
    );
  }
);

LocationField.propTypes = {
  clearButton: PropTypes.bool,
  absolute: PropTypes.bool,
  base: PropTypes.string,
  id: PropTypes.string,
  filter: PropTypes.object,
  isForm: PropTypes.bool,
};

export default LocationField;
